module.exports = __webpack_public_path__ + "static/media/features-ic-01.21eb92bb.svg";